import React, { Component, Suspense } from 'react'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import './scss/style.scss'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
// const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
// const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
// const Cookie = React.lazy(() => import('./views/RBLT/cookie'))

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route path="*" name="Home" element={
              <RequireAuth redirectTo="/login">
                <DefaultLayout />
              </RequireAuth>
              } />
          </Routes>
        </Suspense>
      </BrowserRouter>
    )
  }
}

const getAuth = () => {
  // console.log("authenticated check here")

  if((localStorage.getItem('username')) && (localStorage.getItem('username') !='')){
    if((localStorage.getItem('isloggedin')) && (localStorage.getItem('isloggedin') ==='loggedin')){
      // console.log("Returning true");
      if((localStorage.getItem('version') === null) || (localStorage.getItem('version') !='1.01') || localStorage.getItem('version') ===''){
          return false
      }
      return true;
    }
  }

  // console.log("Returning false");
  return false;
}

function RequireAuth({ children, redirectTo }) {
  let isAuthenticated = getAuth();
  return isAuthenticated ? children : <Navigate to={redirectTo} />;
}

export default App
